import { Option } from 'types';

import { FormItem } from 'sections/EditForm';

import { CheckboxItem } from 'components/CheckboxWithControl';

const exampleData = {
  name_en: 'MD2993S_1VC_466',
  name_it: 'MD2993S_1VC_466',
  code: 'MD2993S_1VC_466',
  barcode: '',
  usage_en: '',
  usage_it: '',
  intro_en: '',
  intro_it: '',
  description_en: '',
  description_it: '',
  category: '',
  march: '',
  weight: '1,00',
  type: '',
};

const typeGroup: CheckboxItem[] = [
  {
    name: 'promotion',
    label: 'Promotion',
    value: '',
  },
  {
    name: 'balance',
    label: 'Balance',
    value: '',
  },
  {
    name: 'shop_window',
    label: 'Shop Window',
    value: '',
  },
  {
    name: 'draft',
    label: 'Draft',
    value: '',
  },
];

const marchOptions: Option[] = [
  {
    value: 'Colmar',
    label: 'Colmar',
  },
];

const formData: FormItem[] = [
  {
    name: 'code',
    value: exampleData.code,
    label: 'Code',
  },
  {
    name: 'barcode',
    value: exampleData.barcode,
    label: 'Barcode',
  },
  {
    name: 'name_en',
    value: exampleData.name_en,
    label: 'Name',
    flag: 'en',
  },
  {
    name: 'name_it',
    value: exampleData.name_it,
    flag: 'it',
  },
  {
    name: 'usage_en',
    value: exampleData.usage_en,
    label: 'Usage',
    flag: 'en',
  },
  {
    name: 'usage_it',
    value: exampleData.usage_it,
    flag: 'it',
  },
  {
    name: 'intro_en',
    value: exampleData.intro_en,
    label: 'Intro',
    flag: 'en',
    type: 'textbox',
  },
  {
    name: 'intro_it',
    value: exampleData.intro_it,
    flag: 'it',
    type: 'textbox',
  },
  {
    name: 'description_en',
    value: exampleData.description_en,
    label: 'Description',
    type: 'textbox',
    flag: 'en',
  },
  {
    name: 'description_it',
    value: exampleData.description_it,
    type: 'textbox',
    flag: 'it',
  },
  {
    name: 'category',
    value: exampleData.category,
    label: 'Category',
    type: 'select',
    options: [],
  },
  {
    name: 'marche',
    value: exampleData.march,
    label: 'March',
    type: 'select',
    options: marchOptions,
  },
  {
    name: 'weight',
    value: exampleData.weight,
    label: 'Weight',
  },
  {
    name: 'type',
    value: exampleData.type,
    label: 'Type',
    type: 'checkbox',
    checkboxGroup: typeGroup,
  },
];

export { formData };
